import { FaCode, FaDesktop } from 'react-icons/fa'; // Importing icons from react-icons

const servicesData = [
  {
    id: 1,
    icon: <FaDesktop />, // Icon for Frontend Development
    title: 'Frontend Development',
    desc: 'Crafting engaging user interfaces using HTML, CSS, and JavaScript frameworks to bring designs to life and ensure a seamless user experience.',
  },
  {
    id: 2,
    icon: <FaCode />, // Icon for MERN Stack Development
    title: 'MERN Stack Development',
    desc: 'Building robust full-stack applications using MongoDB, Express.js, React, and Node.js, integrating databases, servers, and front-end elements for dynamic web applications.',
  }
];

export default servicesData;
